<template>
    <h1>Search Results: {{searchQuery}}</h1>
</template>
<script>
    // Module Code
    export default {
        props:['searchQuery'],
        data: function() {
            return {}
        }
    }
</script>